import { apiFetch } from '../api-client';

export type AssistantMode = 'query' | 'explain' | 'forecast';

export interface AssistantAnswer {
  answer: string;
  source: string;
  confidence: number;
  actions: string[];
}

export const aiAssistantApi = {
  ask: (question: string, mode: AssistantMode, page: string) => apiFetch<AssistantAnswer>('/api/ai-assistant/ask', {
    method: 'POST',
    body: JSON.stringify({ question, mode, page }),
  }),
};
